<template>
  <div>
     <el-row>
      <el-col :span="18">
        <h3>Ladders List</h3>
        <span class="description"
          >View active competition ladders. Ladders are automatically generated daily for competitions with ladder settings set up. It's also possible to update them on demand by selecting the ladder from the list below and click Update in the next screen.</span
        >
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row class="search-bar">
      <el-col class="sync-buttons">
        <el-button v-if="!bulkSync" @click="bulkSyncToggle">Bulk Sync</el-button>
        <el-button v-if="bulkSync" @click="deselectAllBulk">Deselect All</el-button>
        <el-button v-if="bulkSync" @click="selectAllBulk">Select All</el-button>
        <el-button v-if="bulkSync" @click="cancelSync">Cancel</el-button>
        <el-button v-if="bulkSync" @click="bulkSyncSubmit" type="primary">Confirm</el-button>
        <div class="season-filter">
          <span>Season:</span>
          <el-select class="season-filter-select" v-model="filterSeason" placeholder="Season" @change="fetchData">
            <el-option
              v-for="season in seasons"
              :key="season.value"
              :label="season.label"
              :value="season.value"
            ></el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :offset="2" :span="16">
        <el-input
          autocomplete="off"
          v-model="filters.criteria"
          prefix-icon="el-icon-search"
          placeholder="Start typing to search...">
        </el-input>
      </el-col>
    </el-row>
    <data-tables-server
      v-loading="loading"
      :data="tableData"
      :table-props="tableProps"
      :pagination-props="paginationProps"
      :page-size="queryInfo.pageSize"
      :current-page.sync="queryInfo.page"
      :total="total"
      @query-change="queryChange"
      @row-click="handleClickCond"
      class="data-table mt-1">
      <el-table-column width="70" v-if="bulkSync">
        <template slot-scope="scope">
          <el-checkbox
            @change="handleCheck(scope.row.competition._id, $event)"
            v-model="scope.row.checked"
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="_id" label="ID" width="100"/>
      <el-table-column prop="competition.name" label="Competition" width="170"/>
      <el-table-column prop="competition.season" label="Season">
        <template slot-scope="scope">
          {{ getSeasonName(scope.row.competition.season) }}
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="Created At" :formatter="dateFormatter" />
      <el-table-column prop="modifiedAt" label="Last Modified" :formatter="dateFormatter" />
    </data-tables-server>
  </div>
</template>

<script>
import _ from 'lodash';
import { timedate } from '@/utils/timedate';
// import { seasons } from '@/utils/constants';

export default {
  name: 'LaddersList',
  props: {
  },
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      queryInfo: {
        pageSize: 20,
        page: 1
      },
      filters: {
        criteria: this.$store.state.ladders.criteria
      },
      tableProps: {
        border: false,
        'max-height': 800
      },
      paginationProps: {
        pageSizes: [20, 50, 100],
      },
      // seasons,
      bulkSync: false,
      idsChecked: [],
      seasons: this.$store.getters['season/seasons'],
      filterSeason: null,
    };
  },
  mounted() {
    const currentSeason = this.seasons.find((season) => _.get(season, 'currentSeason', false));
    this.filterSeason = currentSeason ? currentSeason.value : null;
    this.fetchStore();
  },
  methods: {
    selectAllBulk() {
      this.idsChecked = this.tableData.map((row) => row.competition._id);
    },
    deselectAllBulk() {
      this.idsChecked = [];
    },
    isChecked(_id) {
      return this.idsChecked.includes(_id);
    },
    handleCheck(_id, val) {
      if (val) {
        this.idsChecked.push(_id);
      } else {
        this.idsChecked = this.idsChecked.filter((id) => id !== _id);
      }
    },
    handleClickCond(row) {
      if (!this.bulkSync) {
        this.handleRowClick(row);
      }
    },
    cancelSync() {
      this.bulkSync = false;
    },
    bulkSyncToggle() {
      this.bulkSync = true;
    },
    async bulkSyncSubmit() {
      try {
        const confirmResult = await this.$confirm('This will sync the selected ladders. Continue?', 'Warning', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        });
        if (confirmResult !== 'confirm') return;
        await this.$http.post('/assemble/api/v1/admin/ladders/bulk-sync', {
          compids: this.idsChecked
        });
        this.$message.success('Bulk sync successful');
      } catch (error) {
        console.error(error);
        this.$message.error('An error occurred, please try again');
      }

      this.bulkSync = false;
    },
    getSeasonName(season) {
      return _.find(this.seasons, { value: season }).label;
    },
    fetchStore() {
      const { data, pagination: { total, pageSize, page } } = this.$store.state.ladders;
      if (data.length) {
        this.total = total;
        _.assign(this.queryInfo, { pageSize, page });
        this.tableData = data;
        return true;
      }
      return false;
    },
    queryChange(queryInfo) {
      this.queryInfo = queryInfo;
      if (!this.$store.state.ladders.data.length || queryInfo.type !== 'init') this.fetchData();
    },
    fetchData() {
      this.loading = true;
      const { criteria: name } = this.filters;
      const { pageSize, page } = this.queryInfo;
      this.$http
        .get(`/assemble/api/v1/admin/ladders/data-table/${pageSize}/${page}`, {
          params: {
            name,
            season: this.filterSeason
          }
        })
        .then((response) => {
          this.$set(this, 'tableData', response.data.data.pageData);
          this.$set(this, 'total', response.data.data.total);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$message.error('An error happened');
        });
    },
    handleRowClick(row) {
      this.$router.push({
        name: 'ladders.update',
        params: {
          type: 'update',
          comp: row,
          id: row._id,
        },
      });
    },
    dateFormatter(r, c, v) {
      return v ? timedate.set(v).fDateTime() : '';
    },
  },
  watch: {
    tableData(data) {
      this.$store.commit('ladders/updateData', data);
      this.$store.commit('ladders/updatePagination', { data: { ..._.pick(this.queryInfo, ['pageSize', 'page']), total: this.total } });
    },
    // eslint-disable-next-line func-names
    'filters.criteria': _.debounce(function (criteria) {
      this.$store.commit('ladders/updateCriteria', criteria);
      this.fetchData();
    }, 500),
    idsChecked() {
      // eslint-disable-next-line no-restricted-syntax
      for (const row of this.tableData) {
        row.checked = this.idsChecked.includes(row.competition._id) === true;
      }
    },
  }
};
</script>

<style scoped lang="scss">
  .search-bar {
    display: flex;
    margin-bottom: 1rem;
  }

  .data-table {
      width: 100%;
  }
  ::v-deep .el-pagination {
    margin-top: 2rem !important;
  }

  .sync-buttons {
    display: flex;
  }

  .season-filter {
    margin-left: 1.5rem;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  .season-filter-select {
    margin-left: 1rem;
    width: 120px;
  }
</style>
